<template>
  <div class="app-wrapper">
    <div class="main-container">
      <navbar :left-arrow="$route.path!=='/page/paysuccess'" />
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { Navbar, AppMain } from './components'

export default {
  name: 'page',
  components: {
    Navbar,
    AppMain
  },
  created () {
    console.log(this.$route)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-wrapper {
  height: 100%;
  width: 100%;
  .main-container {
    height: 100%;
    width: 100%;
    overflow-y: scroll;
    position: relative;
    display: flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/page/page.vue